import axios, { AxiosInstance } from 'axios';

const BASE_URL = `${process.env.REACT_APP_ID_HOST_URL}`;

const axiosIdInstance: AxiosInstance = axios.create({
  baseURL: `${BASE_URL}/api`,
});

axiosIdInstance.interceptors.request.use((config) => {
  if (!config?.headers) {
    throw new Error(`Expected 'config' and 'config.headers' not to be undefined`);
  }

  return config;
});

export default axiosIdInstance;
